import {z} from 'zod';
import {ELEMENT} from '../../elements/base/ElementTypes';

export const chatbotValidator = z.object({
    type: z.literal(ELEMENT.CHATBOT),
    header: z.string().min(1, {
        message: 'presEditPage.editSidebar.elements.chatbot.nameRequired',
    }),
    profile: z.string().min(1, {
        message: 'presEditPage.editSidebar.elements.chatbot.profileRequired',
    }),
    therapy: z.string().min(1, {
        message: 'presEditPage.editSidebar.elements.chatbot.therapyRequired',
    }),
    diagnosis: z.string().min(1, {
        message: 'presEditPage.editSidebar.elements.chatbot.diagnosisRequired',
    }),
});
